/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

function isEmpty(item) {
    if (typeof item === 'undefined' || item === null) return true;
    // return Object.keys(item).length === 0 && item.constructor === Object;
    // return Object.keys(item).length === 0 && item.constructor === Array;
    return Object.keys(item).length === 0;
}

export {
    isEmpty,
};

export default {};
